import React from 'react';
import './Baby.css';
import usePageMeta from '../../hooks/usePageMeta';
import {
  FaBaby,
  FaUsers,
  FaUserFriends,
  FaShoppingBag,
  FaMoneyBillWave,
  FaLink,
  FaChartBar,
  FaGift,
} from 'react-icons/fa';

const iconColor = '#5128b5';
const iconSize = 28;

const Baby: React.FC = () => {
  usePageMeta({
    title: 'UpdateCommit Baby',
    description:
      'UpdateCommit Baby: plataforma gratuita para criar a vaquinha e a lista de presentes do seu bebê. Compartilhe com amigos e família e receba contribuições via PIX direto na sua conta.',
    path: '/solucoes/baby',
  });

  return (
    <div className="baby-page">

      {/* Hero */}
      <div className="baby-hero">
        <div className="baby-container">
          <span className="baby-badge">✨ Gratuito</span>
          <div className="baby-logo-mark">
            <FaBaby color={iconColor} size={48} />
          </div>
          <h1 className="baby-title">
            UpdateCommit <span className="baby-highlight">Baby</span>
          </h1>
          <p className="baby-subtitle">
            A plataforma gratuita para criar a vaquinha e lista de presentes do seu bebê.
            Compartilhe com amigos e família, e receba contribuições direto na sua conta.
          </p>
          <a
            href="https://baby.updatecommit.com"
            target="_blank"
            rel="noopener noreferrer"
            className="baby-cta-btn"
          >
            Criar minha página agora →
          </a>
        </div>
      </div>

      {/* Como funciona */}
      <div className="baby-section">
        <div className="baby-container">
          <h2 className="baby-section-title">Como funciona</h2>
          <p className="baby-section-sub">
            Simples para quem cria, simples para quem contribui.
          </p>

          <div className="baby-personas">

            {/* Pai/Mãe */}
            <div className="baby-persona-card">
              <div className="baby-persona-icon" style={{ background: '#f5f5f5' }}>
                <FaUsers color="#5128b5" size={iconSize} />
              </div>
              <h3>Para o pai e a mãe</h3>
              <p className="baby-persona-sub">Quem cria a página</p>
              <ul className="baby-steps">
                <li><span className="baby-step-num">1</span>Crie sua conta com e-mail</li>
                <li><span className="baby-step-num">2</span>Configure a página: nome do bebê, data prevista do parto, cores, chave PIX, meta de arrecadação e URL personalizada</li>
                <li><span className="baby-step-num">3</span>Compartilhe o link com amigos e família</li>
                <li><span className="baby-step-num">4</span>Acompanhe tudo no dashboard: contribuições recebidas, confirmações de PIX e produtos da lista</li>
              </ul>
            </div>

            {/* Visitantes */}
            <div className="baby-persona-card">
              <div className="baby-persona-icon" style={{ background: '#f5f5f5' }}>
                <FaUserFriends color="#5128b5" size={iconSize} />
              </div>
              <h3>Para amigos e família</h3>
              <p className="baby-persona-sub">Quem visita a página</p>
              <ul className="baby-steps">
                <li><span className="baby-step-num">1</span>Acesse o link recebido — sem precisar criar conta</li>
                <li><span className="baby-step-num">2</span>Veja a página com nome do bebê, progresso da gestação em semanas e a meta da vaquinha</li>
                <li><span className="baby-step-num">3</span>Deixe uma mensagem carinhosa com seu nome</li>
                <li><span className="baby-step-num">4</span>Para contribuir, informe o valor e receba a chave PIX — a transferência vai direto para a conta do pai ou da mãe, sem intermediários</li>
              </ul>
            </div>

            {/* Produtos */}
            <div className="baby-persona-card">
              <div className="baby-persona-icon" style={{ background: '#f5f5f5' }}>
                <FaShoppingBag color="#5128b5" size={iconSize} />
              </div>
              <h3>Lista de produtos</h3>
              <p className="baby-persona-sub">Itens que aparecem na página</p>
              <ul className="baby-steps">
                <li><span className="baby-step-num">1</span>No seu dashboard, adicione URLs de produtos que você deseja receber</li>
                <li><span className="baby-step-num">2</span>Os produtos ficam visíveis para todos os visitantes da sua página</li>
                <li><span className="baby-step-num">3</span>Amigos e família podem ver o que você quer e presentear de forma certeira</li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* Destaques */}
      <div className="baby-highlights-section">
        <div className="baby-container">
          <div className="baby-highlights-grid">
            <div className="baby-highlight-item">
              <FaMoneyBillWave color={iconColor} size={iconSize}  className="baby-highlight-icon" style={{ display: 'block', margin: '0 auto 12px' }} />
              <h4>Dinheiro vai direto</h4>
              <p>O PIX vai direto para sua conta. A plataforma não fica com nada.</p>
            </div>
            <div className="baby-highlight-item">
              <FaLink color={iconColor} size={iconSize} className="baby-highlight-icon"  style={{ display: 'block', margin: '0 auto 12px' }} />
              <h4>URL personalizada</h4>
              <p>Crie uma URL bonita e fácil de compartilhar para a sua família.</p>
            </div>
            <div className="baby-highlight-item">
              <FaChartBar color={iconColor} size={iconSize} className="baby-highlight-icon"  style={{ display: 'block', margin: '0 auto 12px' }} />
              <h4>Dashboard completo</h4>
              <p>Veja em tempo real quem contribuiu e quanto já foi arrecadado.</p>
            </div>
            <div className="baby-highlight-item">
              <FaGift color={iconColor} size={iconSize} className="baby-highlight-icon"  style={{ display: 'block', margin: '0 auto 12px' }} />
              <h4>Totalmente gratuito</h4>
              <p>Sem taxas, sem mensalidade. Crie e compartilhe de graça.</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Final */}
      <div className="baby-cta-section">
        <div className="baby-container baby-cta-inner">
          <h2>Pronto para criar a página do seu bebê?</h2>
          <p>É grátis, rápido e o dinheiro vai direto para você.</p>
          <a
            href="https://baby.updatecommit.com"
            target="_blank"
            rel="noopener noreferrer"
            className="baby-cta-btn"
          >
            Acessar baby.updatecommit.com →
          </a>
        </div>
      </div>

    </div>
  );
};

export default Baby;